import { useState } from "react";
import { Card, CardBody, Col, Toast, ToastHeader } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import UniqueToastContent from "./Common/UniqueToastContent";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { UniqueToastTitle } from "../../../Constants/Constants";
import { ColorsSchemeSubTitle } from "../../../Data/BonusUi/Toasts";

const UniqueToast = () => {
  const [visible, setVisible] = useState(true);
  const toggle = () => setVisible(!visible);
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={UniqueToastTitle} span={ColorsSchemeSubTitle} />
        <CardBody className="toast-rtl">
          <Toast isOpen={visible} fade>
            <ToastHeader className="toast-img" toggle={toggle}>
              <Image className="rounded me-2" src={dynamicImage(`product-lists/profile.png`)} alt="profile" />
              <strong className="me-auto">{"Berlin Theme"}</strong>
            </ToastHeader>
            <UniqueToastContent visible={visible} setVisible={setVisible} />
          </Toast>
        </CardBody>
      </Card>
    </Col>
  );
};
export default UniqueToast;
